import axios from 'axios'

// Base API URL - dynamically determined from current hostname
const baseURL = process.env.VUE_APP_API_BASE_URL || 
  ((window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:8000/api'
    : 'https://precious-madeleine-illyra-hcetqms-finapp-b8c92782.koyeb.app/api');

// Create axios instance with default config for kiosk
const kioskApi = axios.create({
  baseURL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Add request interceptor with opt-out for kiosk routes
kioskApi.interceptors.request.use(config => {
  // NEVER add auth token to these routes
  const publicRoutes = [
    '/kiosk/transactions',
    '/kiosk/transactions/test',
    '/students/id-number',
    '/transaction-types',
    '/priority-codes/verify',
    '/kiosk/flow-config',
    '/settings/kiosk'
  ]

  // Check if URL starts with any of our public routes
  const isPublicRoute = publicRoutes.some(route =>
    config.url?.startsWith(route) || config.url?.includes('/kiosk/')
  )

  // If it's a public route, don't add the auth token
  if (isPublicRoute) {
    return config
  }

  // Otherwise, attach Bearer token if present
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})

// Add response interceptor to detect authentication issues
kioskApi.interceptors.response.use(
  response => response, // For successful responses, just return as is
  error => {
    // Check if this is an authentication error
    if (error.response && error.response.status === 401) {
      console.error('Authentication error in kioskApi:', {
        url: error.config.url,
        method: error.config.method,
        hasAuthHeader: !!error.config.headers['Authorization'],
        errorMessage: error.response.data.message || 'Unauthorized'
      })
    }
    return Promise.reject(error)
  }
)

// Export kiosk-specific API methods
export const kioskTransactionsApi = {
  getActiveTypes() {
    return kioskApi.get('/transaction-types')
      .then(response => {
        // Ensure is_active is boolean for each type and filter active ones
        if (response.data) {
          response.data = response.data
            .map(type => ({
              ...type,
              is_active: Boolean(type.is_active)
            }))
            .filter(type => type.is_active);
        }
        return response;
      });
  },

  getTypeRequirements(typeId) {
    return kioskApi.get(`/transaction-types/${typeId}/requirements`);
  },

  createTransaction(transactionData) {
    return kioskApi.post('/kiosk/transactions', transactionData);
  },

  getTransaction(transactionId) {
    return kioskApi.get(`/kiosk/transactions/${transactionId}`);
  },

  testTransaction(transactionData) {
    return kioskApi.post('/kiosk/transactions/test', transactionData);
  },

  printTicket(transactionId, printerName) {
    // If printer name is provided, send it in the request body
    if (printerName) {
      return kioskApi.post(`/kiosk/transactions/${transactionId}/print`, { printer_name: printerName });
    }
    // Otherwise use the original method without a request body
    return kioskApi.post(`/kiosk/transactions/${transactionId}/print`);
  }
}

export const kioskStudentsApi = {
  getStudentByIdNumber(idNumber) {
    return kioskApi.get(`/students/id-number/${idNumber}`);
  }
}

export default {
  transactions: kioskTransactionsApi,
  students: kioskStudentsApi
} 